import React from 'react';
import { Code, Rocket, Gauge, Shield, Repeat, ChevronLeft, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MicroSaas() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700">
              <ChevronLeft className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
            <a 
              href="https://wa.me/60177751631"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 hover:text-green-700"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Contact on WhatsApp</span>
            </a>
          </div>
        </nav>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
          <Code className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Micro SaaS Development</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Build and scale custom AI-powered software solutions tailored to your business needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-2xl font-bold mb-6">Development Process</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Rocket className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Rapid Development</h3>
                  <p className="text-gray-600">Quick iterations with continuous feedback and improvements.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Gauge className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Performance Optimization</h3>
                  <p className="text-gray-600">Built for speed, scalability, and optimal resource usage.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Shield className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Security First</h3>
                  <p className="text-gray-600">Enterprise-grade security measures and data protection.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Repeat className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Continuous Support</h3>
                  <p className="text-gray-600">Ongoing maintenance, updates, and technical support.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80"
              alt="Software Development"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold mb-4">Solution Types</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Custom AI Applications</li>
                <li>• Business Process Automation</li>
                <li>• Data Analytics Platforms</li>
                <li>• Integration Solutions</li>
                <li>• Scalable Web Applications</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/#contact"
            className="inline-flex items-center bg-indigo-600 text-white px-8 py-3 rounded-lg hover:bg-indigo-700 transition"
          >
            Start Your Project
          </Link>
        </div>
      </div>
    </div>
  );
}